import { memo } from 'react'
import Select from 'react-select'
import { PicklistStatusDesc } from '../constants/EnumType'

const SelectMultiOption = ({ 
  title, optionEnum, values, onChanged, className = ''
}: { title: string, optionEnum: string[], values: string[], className?: string 
  onChanged : (values: string[]) => void }) => {
  return <div className={className}>
    <small className='text-muted'>{title}</small>
    <Select
      value={values.map(v => {
        return { value: v, label: getValueByKeyForStringEnum(v) }
      })}
      onChange={(e) => onChanged(e.map( e1 => e1.value ))}
      options={optionEnum.map(value => {
        return { value: value, label: getValueByKeyForStringEnum(value) }
      })}
      isSearchable={false}
      isMulti={true}
      isClearable={false}
    />
  </div>
}

function getValueByKeyForStringEnum(value: string) {
  return Object.entries(PicklistStatusDesc).find(([key, val]) => key === value)?.[1] || value;
}

export default memo(SelectMultiOption)